import { useLayoutEffect } from "react";
import { useAuth } from "@/core/auth";
import { useGetMyUser } from "@/user/query";
import { isTech } from "@/user/utils";
import { setPylonAccessAllowed } from "./pylon-access";

export const useHasPylonAccess = () => {
  const { user: authUser } = useAuth();
  const { data: user } = useGetMyUser();
  return !!user && !!authUser && !isTech(authUser.role) && !isTech(user.role);
};

export const usePylonAccess = () => {
  const hasAccess = useHasPylonAccess();

  useLayoutEffect(() => {
    setPylonAccessAllowed(hasAccess);
    return () => setPylonAccessAllowed(false);
  }, [hasAccess]);

  return hasAccess;
};
